var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraggableIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160605",
    "data-name": "Group 160605",
    transform: "translate(-664 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147762",
    "data-name": "Rectangle 147762",
    width: 2,
    height: 2,
    transform: "translate(664 462)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147767",
    "data-name": "Rectangle 147767",
    width: 2,
    height: 2,
    transform: "translate(668 462)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147763",
    "data-name": "Rectangle 147763",
    width: 2,
    height: 2,
    transform: "translate(664 466)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147766",
    "data-name": "Rectangle 147766",
    width: 2,
    height: 2,
    transform: "translate(668 466)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147764",
    "data-name": "Rectangle 147764",
    width: 2,
    height: 2,
    transform: "translate(664 470)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147765",
    "data-name": "Rectangle 147765",
    width: 2,
    height: 2,
    transform: "translate(668 470)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIcon);
export default __webpack_public_path__ + "static/media/DraggableIcon.e7453339af8181127caff1c1798a2ced.svg";
export { ForwardRef as ReactComponent };